import React from "react";
import PropTypes from "prop-types";
import { IconButton, Tooltip } from "@mui/material";

// *** Use icons from react-icons library for the fontSize to work *** //
function IconNav({ children, label, handleClick }) {
  return (
    <Tooltip title={label}>
      <span className="visually-hidden">{label}</span>
      <IconButton
        aria-label={label}
        sx={{
          padding: { xs: "8px", lg: "10px" },
          fontSize: { xs: 25, lg: 30 },
          color: "white",
          "&:hover": {
            color: "#cd9e0c"
          }
        }}
        onClick={handleClick}
      >
        {children}
      </IconButton></Tooltip>
  );
}

IconNav.propTypes = {
  children: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired
};

export default IconNav;
